import { Override } from '../types';

const overrides: Override = {
  ELI: {
    'Study Article 23: July 31–August 6 20': 'Study Article 23: July 31, 2023–August 6, 2023',
  },
  PGW: {
    'Fine-Fine Things Wey You See for Bible': 'Fine-Fine Things Wey You See for Bible: (10 min.)',
  },
  ST: {
    'Seda artiklit uuritakse vahemikus 28. oktoobrist 3.novembrini 2024.':
      'Seda artiklit uuritakse vahemikus 28. oktoobrist 3. novembrini 2024.',
  },
  SW: {
    '7. Video ya Machi ya Mambo Yaliyotimizwa na Tengenezo (10 min.) Onyesha VIDEO.':
      '7. Video ya Machi ya Mambo Yaliyotimizwa na Tengenezo (Dak. 10) Onyesha VIDEO.',
  },
  YW: {
    '4. Gutangiza ikiganiro (Umun. 1) KUBWIRIZA KU NZU N’INZU. Umubwiriza asange umuntu avuga urundi rurimi. (lmd isomo rya 2 ingingo ya 5)':
      '4. Gutangiza ikiganiro (Imin. 1) KUBWIRIZA KU NZU N’INZU. Umubwiriza asange umuntu avuga urundi rurimi. (lmd isomo rya 2 ingingo ya 5)',
  },
};

export default overrides;
